// extracted by mini-css-extract-plugin
export default {"signFormRolesList":"styles_signFormRolesList__oAvNc","formRolePillButton":"styles_formRolePillButton__YWlfY"};